/* eslint-disable no-nested-ternary */
import { FlexRowCenter } from 'styles/global-styles';
import styled, { css } from 'styled-components';
import {
  I_HotspotConfigGlobal,
  I_HotspotConfigStyle,
  I_MediaInteraction,
} from '@containers/Home/types';
import {
  COLOR_HOTSPOT_BG_DEFAULT,
  COLOR_HOTSPOT_ICON_DEFAULT,
} from '@containers/Home/constants';
import { bounce, pulse, pulseCallout, dash } from './animation';

export const ShapeIconWrapper = styled.div<
  I_HotspotConfigGlobal & {
    // icon_fontSize?: number;
    // shape_fontSize?: number;
    // shape_color?: string;
  }
>`
  ${FlexRowCenter};
  width: 100%;
  height: 100%;
  /* background-color: var(--color-theme); */
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  ${props =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor || 'var(--color-red)'};
    `}

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: ${props => props.iconColor || '#fff'};
    }
  }
`;

export const ImageIconWrapper = styled.img`
  width: 100%;
  height: auto;
`;

export const LottieIconWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const MarkerIconWrapper = styled.div<{ color?: string }>`
  position: relative;
  svg {
    ${props =>
      props.color &&
      css`
        fill: ${props.color};
      `}
  }
  path {
    ${props =>
      props.color &&
      css`
        fill: ${props.color};
      `}
  }
  img {
    position: absolute;
    border-radius: 50%;
    height: auto;
    width: 70%;
    height: auto;
    aspect-ratio: 1/1;
    left: 0;
    right: 0;
    top: 10%;
    margin: auto;
  }
  #id_marker1 {
    img {
      top: 11%;
    }
  }
  #id_marker2 {
    img {
      top: 9%;
      border-radius: 10%;
    }
  }
  #id_marker3 {
    img {
      top: 9.5%;
    }
  }
  #id_marker4 {
    img {
      top: 11%;
    }
  }
  #id_marker5 {
    img {
      top: 11%;
    }
  }
  #id_marker6 {
    img {
      top: 8%;
    }
  }
  #id_marker7 {
    img {
      top: 9.5%;
    }
  }
  #id_marker8 {
    img {
      top: 12%;
    }
  }
  #id_marker9 {
    img {
      top: 12%;
    }
  }
  #id_marker10 {
    img {
      top: 9%;
    }
  }
  #id_marker11 {
    img {
      top: 10.5%;
    }
  }
  #id_marker12 {
    img {
      top: 10%;
    }
  }
  #id_marker13 {
    img {
      top: 10%;
    }
  }
  #id_marker14 {
    img {
      top: 11.5%;
    }
  }
  #id_marker15 {
    img {
      top: 7.5%;
    }
  }
  #id_marker16 {
    img {
      border-radius: 10%;
      top: 10%;
      width: 64%;
    }
  }
`;

export const DefaultIconWrapper = styled.div<I_HotspotConfigGlobal>`
  background: ${props => props.bgColor || COLOR_HOTSPOT_BG_DEFAULT};
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  ${FlexRowCenter};
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: var(--transition-smooth);
  i {
    font-size: 18px;
    color: ${props => props.iconColor || COLOR_HOTSPOT_ICON_DEFAULT};
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: scale(1.2);
    }
  }
`;

export const HotspotWrapper = styled.div<{
  isHidden;
  type: I_HotspotConfigStyle['type'];
  size?: number;
  rotate?: number;
  opacity?: number;
}>`
  ${props =>
    props.isHidden &&
    css`
      visibility: hidden;
    `}
  position: relative;
  width: ${props =>
    (props.type === 'image'
      ? 24
      : props.type === 'marker'
      ? 20
      : props.type === 'lottie'
      ? 32
      : 10.7) * (props.size || 3)}px;
  height: ${props =>
    props.type === 'image' || props.type === 'marker' || props.type === 'lottie'
      ? 'auto'
      : `${10.7 * (props.size || 3)}px`};
  .content {
    width: 100%;
    height: 100%;
    opacity: ${props => props.opacity};
    transform: rotate(${props => props.rotate}deg);
    ${ShapeIconWrapper}, ${DefaultIconWrapper} {
      i {
        font-size: ${props => 4.7 * (props.size || 3)}px;
      }
    }
    animation-iteration-count: infinite;
    animation-duration: var(--animate-duration) !important;
    ${FlexRowCenter};
    &.pulse-grow {
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.25);
      animation: ${pulse} 1.5s infinite;
      animation-duration: 1500ms !important;
    }
    &.raise {
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.25);
      animation: ${props =>
          bounce(
            props.type === 'image' ? 'auto' : `${14 * (props.size || 3)}px`,
          )}
        500ms infinite alternate cubic-bezier(0.2, 0.65, 0.6, 1);
      animation-duration: 2000ms !important;
    }
    border-radius: 50%;
    position: relative;
  }
  .--title {
    color: #fff;
    top: -32px;
    left: 50%;
    min-width: 100%;
    font-weight: 600;
    text-align: center;
    position: absolute;
    white-space: nowrap;
    background: rgba(0, 0, 0, 0.35);
    border-radius: 4px;
    padding: 4px 6px;
    z-index: 20;
    transform: translate(-50%);
    text-shadow: 0 1px 4px #000;
    em {
      color: #fff;
      text-align: center;
      font-style: initial;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const HotspotMediaWrapper = styled.div<I_MediaInteraction>`
  width: ${props => props.width} !important;
  height: ${props => props.height} !important;
  transform: ${props => props.transform}
    rotate(${props => props.rotate || 0}deg);
  background-color: ${props => props.backgroundColor};
  opacity: ${props => props.opacity};
  position: absolute;
  top: 0;
  left: 0;
  z-index: -111;
  transform-origin: 0 0;
  .target {
    width: 100%;
    height: 100%;
    object-fit: ${props => props.displayType};
  }
  i {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    color: #fff;
    background: rgb(0 0 0 / 0.5);
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    transition: var(--transition-smooth);
    transform: scale(0.5);
    opacity: 0;
    cursor: pointer;
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      i {
        transform: scale(1);
        opacity: 1;
      }
    }
  }
`;

export const CalloutIconWrapper = styled.div<{ degrees?: number }>`
  width: 50%;
  height: 50%;
  .calloutWrapper {
    width: 100%;
    height: 100%;
    .point {
      width: 100%;
      height: 100%;
      .--dot {
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 50%;
        animation: ${pulseCallout} ease-out 3s forwards infinite;
      }
    }
    .--main {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%)
        rotate(${props => props.degrees || 45}deg);
      transform-origin: left bottom;
    }
    .line {
      width: 0;
      height: 2px;
      background-color: #fff;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      left: 50%;
      transition: var(--transition-smooth);
    }
    .--content {
      position: absolute;
      left: 120px;
      top: 50%;
      &.--type-text {
        height: 2px;
        transform-origin: bottom left;
        transform: translateY(-50%)
          rotate(${props => -(props.degrees || 45)}deg);
        .--img {
          display: none;
        }
        .--line {
          width: 0;
          // width: 100%;
          height: 2px;
          margin-left: -1px;
          background-color: #fff;
          transition: var(--transition-smooth);
          svg {
            display: none;
          }
        }
        .--text {
          width: 0;
          transition: var(--transition-smooth);
          overflow: hidden;
          pointer-events: none;
          transform: translateY(calc(-100% + 20px));
          &:after {
            content: '';
            width: 2px;
            height: 0;
            background: #fff;
            display: block;
            transition: var(--transition-smooth);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .--inner {
          width: max-content;
          pointer-events: auto;
          position: relative;
          max-width: 280px;
          @media (max-width: 575px) {
            max-width: 200px;
          }
        }
        .--mainTitle {
          background: var(--color-primary);
          color: var(--color-text);
          display: block;
          padding: 4px 12px;
          width: max-content;
          // margin-bottom: 6px;
          font-size: 0.9rem;
          font-weight: 700;
          line-height: 20px;
          max-width: 100%;
          width: 100%;
        }
        article {
          color: #fff;
          font-weight: 500;
          text-shadow: 0 1px 4px #000;
          max-width: 100%;
          background: rgba(0, 0, 0, 0.35);
          padding: 10px;
        }
      }
      &.--type-img {
        transform: translate(-20px, -50%)
          rotate(${props => -(props.degrees || 45)}deg);
        width: 160px;
        height: 160px;
        .--line {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: calc(100% + 10px);
          height: calc(100% + 10px);
          z-index: -1;
          svg {
            display: block;
            width: 100%;
            height: 100%;
            @media (max-width: 575px) {
              circle {
                stroke-width: 4px;
                r: 60px;
              }
            }
          }
          #path {
            stroke-dasharray: 800;
            opacity: 0;
          }
        }
        .--text {
          display: none;
        }
        .--img {
          width: 0;
          height: 0;
          overflow: hidden;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: var(--transition-smooth);
        }
        .--inner {
          width: max-content;
          height: max-content;
          pointer-events: auto;
          position: relative;
        }
      }

      .--img {
        .--inner {
          img {
            width: 160px;
            height: 160px;
            border-radius: 50%;
            object-fit: cover;
            @media (max-width: 575px) {
              width: 120px;
              height: 120px;
            }
          }
        }
      }
    }
    &.active {
      width: 120px;
      height: 120px;
      .line {
        width: 120px;
      }
    }
    &.show {
      .line {
        width: 120px;
      }
      .--content {
        &.--type-text {
          .--line {
            /* width: 100%; */
            /* transition-delay: 0.8s; */
          }
          .--text {
            width: 100%;
            transition-delay: 0.8s;
            &:after {
              height: 100%;
              transition-delay: 0.8s;
            }
          }
        }
        &.--type-img {
          .--img {
            width: 100%;
            height: 100%;
            opacity: 1;
            transition-delay: 0.8s;
            img {
            }
          }
          #path {
            opacity: 1;
            animation: ${dash} 2s ease-out forwards;
            animation-delay: 0.5s;
            transition-delay: 0.5s;
          }
        }
      }
    }
  }
`;
